import React, { useEffect, useState } from "react";
import * as Style from "./styles/items";
// import { useLocation } from "react-router-dom";
import { MODULE_API } from "../../../../../apis";
// import { Button } from "../../../../styled-components/button";
import { Button } from "antd";

import "../../../../../components/form/inventory/inventory.style.css";
import StyledRow from "../../../../styled-components/styled-row/styled-row";
import { useSelector } from "react-redux";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import { Text } from "../../../../styled-components/text";
import AddSimpleModal from "../../../../styled-components/modal/add-simple-modal/add-simple-modal";
import IconInput from "../../../../styled-components/input/icon-input";
import addIcon1 from "../../../../../assets/images/DeathModuleNew/addIcon.png";
import tableimg from "../../../../../assets/images/big/camera.png";

import swal from "sweetalert";
import axios from "axios";
import Loader from "../../../../styled-components/loader/loader";

function Items() {
  const [isLoading, setIsLoading] = useState(false);
  const [itemsToshow, setItemsToShow] = useState();
  const [allItems, setAllItems] = useState([]);
  const [message, setMessage] = useState("");
  const [parentId, setParentId] = useState();
  const [parentImage, setParentImage] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState();
  const [collectibleValue, setCollectibleValue] = useState();
  const [itemsData, setItemsData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modal, setModal] = useState("");
  const [attributesFields, setAttributesFields] = useState();
  const [selectedRowData, setSelectedRowData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { styles } = defaultStyles;

  //   const location = useLocation();
  const selectedModuleName = useSelector(
    (state) => state.rootReducer.inventory.selectedModuleName
  );
  //   console.log("location mdoule name", location.moduleName);

  const fetchItems = async (page) => {
    try {
      setIsLoading(true);
      let itemsResponce = await MODULE_API.fetchItems({
        moduleName: `${selectedModuleName}_item`,
        pageNum: page,
        limit: 10,
        body: {},
      });
      console.log("item", itemsResponce);

      setIsLoading(false);
      if (itemsResponce.status === 200) {
        setMessage(itemsResponce.messageCode);
        // setAllItems(itemsResponce.records);
        if (itemsResponce.records) {
          setAllItems((prevItems) => [...prevItems, ...itemsResponce.records]);
          setTotalPages(Math.ceil(itemsResponce.pagination.total && itemsResponce.pagination.total / 10));
          console.log("pageNumer", page);
          setCurrentPage(page);
        }
        let itemsRecodsToShow = itemsResponce.records.map((itemsRecord) => ({
          "Item Name": itemsRecord["Item Name"],
          Quantity: itemsRecord.Quantity,
          "Price Paid (each)": itemsRecord["Price Paid (each)"] || itemsRecord["Price Paid"],
          "Storage Loaction": itemsRecord["Storage Location"],
          "Updated Value":
            itemsRecord["Update Value (Appraisal or other method, each)"],
          "Est. Total Current value":
            itemsRecord["Estimated Total Current Value"],
        }));
        console.log("itemsRecodsToShow", itemsRecodsToShow);
        const paginationData = itemsResponce.pagination;
        setItemsToShow({
          ["pagination"]: { ...paginationData },
          ["itemsRecords"]: [...itemsRecodsToShow],
        });
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const fetchItemsWithoutUnderscore = async () => {
    try {
      setIsLoading(true);
      let itemsResponce = await MODULE_API.fetchItems({
        moduleName: `${selectedModuleName}`,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      console.log("item without underscore", itemsResponce.status);

      if (itemsResponce.status == 200) {
        console.log("abcccc");
        // setIsLoading(false);
        setParentId(itemsResponce.records[0].id);
        if(itemsResponce.records && itemsResponce.records[0]){
          setParentImage(itemsResponce.records[0].image)
        }
        // fetchRecordTotal(itemsResponce.records[0].id);
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const handleItemsInfo = (obj) => {
    
    const { name, value } = obj;
    let allData={
      ...itemsData,
      [name]: value,
    }

    if (name === "Price Paid (each)" || name === "Quantity") {
      let totalPaid = 0;
      if (name === "Price Paid (each)") {
        totalPaid = +itemsData["Quantity"] * value;
      } else {
        console.log(
          "here in else",
          itemsData["Quantity"],
          itemsData["Price Paid (each)"]
        );
        totalPaid = value * +itemsData["Price Paid (each)"];
      }
      // console.log("itemsDataNew",itemsData["Quantity"],itemsData["Price Paid (each)"])
      // let totalNew=(+itemsData["Quantity"]) * (+itemsData["Price Paid (each)"]);
      console.log("totalPaid", totalPaid, isNaN(totalPaid));     
      // setItemsData({
      //   ...itemsData,
      //   ["Total Paid"]: totalPaid,
      // });
      if (isNaN(totalPaid)) {
        itemsData["Total Paid"] = 0;
        selectedRowData["Total Paid"] = 0;
      } else {
        itemsData["Total Paid"] = totalPaid;
        selectedRowData["Total Paid"] = totalPaid;
      }
      // setSelectedRowData({
      //   ...selectedRowData,
      //   ["Total Paid"]: totalPaid,
      // });
      const estimatedCurrentValue =
        allData["Quantity"] * itemsData["Total Paid"];
      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;
      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    } else if (name === "Update Value (Appraisal or other method, each)") {
      let estimatedCurrentValue = null;
      if (value === "" || value === 0) {
        estimatedCurrentValue = allData["Quantity"] * itemsData["Total Paid"];
      } else {
        estimatedCurrentValue = allData["Quantity"] * value;
      }

      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;

      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    }

    setItemsData({
      ...itemsData,
      [name]: value,
    });
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
    });
  };
  const handleItemsInfoSelect = (name, value) => {
    // console.log("in func");

    // const { name, value } = obj;

    if (name === "Price Paid (each)") {
      const totalPaid = itemsData["Quantity"] * value;
      // console.log("totalPaid",totalPaid);
      // setItemsData({
      //   ...itemsData,
      //   ["Total Paid"]: totalPaid,
      // });
      itemsData["Total Paid"] = totalPaid;
      selectedRowData["Total Paid"] = totalPaid;
      // setSelectedRowData({
      //   ...selectedRowData,
      //   ["Total Paid"]: totalPaid,
      // });
      const estimatedCurrentValue =
        itemsData["Quantity"] * itemsData["Total Paid"];
      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;
      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    } else if (name === "Update Value (Appraisal or other method, each)") {
      let estimatedCurrentValue = null;
      if (value === "" || value === 0) {
        estimatedCurrentValue = itemsData["Quantity"] * itemsData["Total Paid"];
      } else {
        estimatedCurrentValue = itemsData["Quantity"] * value;
      }

      itemsData["Estimated Total Current Value"] = estimatedCurrentValue;

      selectedRowData["Estimated Total Current Value"] = estimatedCurrentValue;
    }

    setItemsData({
      ...itemsData,
      [name]: value,
    });
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
    });
  };
  const handleItemsInfoImageChange = async (obj) => {
    console.log("obj image", obj);
    try {
      setIsLoading(true);
      const imageName = obj.files[0];
      let uploadImg = null;
      let formData = new FormData();
      formData.append("image", imageName);

      // new code signedURL

      const name = obj.files[0].name;
      const lastDot = name.lastIndexOf(".");
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: obj.files[0].type,
      });
      const resupload = await axios.put(resdata.uploadUrl, obj.files[0], {
        headers: { "Content-type": obj.files[0].type },
      });
      const res = resdata.uploadUrl.split("?")[0];
      console.log(res);

      uploadImg = res;
      console.log(res, "upload res");
      itemsData[obj.name] = [res];
      setIsLoading(false);

      // let img = await MODULE_API.uploadImage(formData);
      // if (img && img.status === 200) {
      //   uploadImg = img.file_url;
      //   // setItemsData({
      //   //   ...itemsData,
      //   //   [imageName]: uploadImg,
      //   // });
      //   itemsData[obj.name] = [uploadImg];
      //   setIsLoading(false);
      // }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const fetchAttributes = async () => {
    try {
      setIsLoading(true);
      let attributesResponce = await MODULE_API.fetchAttributes(
        `${selectedModuleName}_item`
      );
      console.log("attributes responce", attributesResponce);
      setAttributesFields(attributesResponce);

      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const fetchRecordTotal = async (recordId) => {
    try {
      setIsLoading(true);
      const recordTotalPayload = {
        attributes: ["Estimated Total Current Value"],
      };
      const recordTotalResponce = await MODULE_API.getRecordTotal(
        recordId,
        recordTotalPayload
      );
      if (recordTotalResponce.status === 200) {
        setCollectibleValue(recordTotalResponce.data.total);
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };
  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("cards-main");
    console.log("Scroll Top:", scrollTop);
    console.log("Scroll Height:", scrollHeight);
    console.log("Client Height:", clientHeight);

    if (scrollTop + clientHeight >= scrollHeight) {
      console.log("Bottom of the scroll reached.");
      console.log("pageee", currentPage, totalPages);
      if (currentPage < totalPages) {
        console.log("Fetching more items...");
        fetchItems(currentPage + 1);
      }
    }
  };

  // Add scroll event listener when component mounts
  useEffect(() => {
    console.log("Attaching scroll event listener.");
    const cardsMainElement = document.getElementById("cards-main");
    cardsMainElement.addEventListener("scroll", handleScroll);
    return () => {
      console.log("Removing scroll event listener.");
      cardsMainElement.removeEventListener("scroll", handleScroll);
    };
  }, [currentPage, totalPages]);
  useEffect(() => {
    // fetchItems();
    // fetchItemsWithoutUnderscore();
    // fetchAttributes();
    fetchAll();
  }, []);
  const fetchAll= async()=>{
    await fetchItems(1);
    await fetchItemsWithoutUnderscore();
    await fetchAttributes();
  }
  const handelCloseModal = () => {
    setShowModal(false);
  };

  const submitData = async () => {
    try {
      console.log("in items submit data", itemsData);
      setIsLoading(true);
      let itemsDataCopy = { ...itemsData };
      itemsDataCopy["parentId"] = parentId;
      const payload = {
        clientModules: [itemsDataCopy],
      };
      console.log("payload", payload);

      if (modal === "Add Modal") {
        const res = await MODULE_API.createClientItem(
          `${selectedModuleName}_item`,
          payload
        );
        setIsLoading(false);
        setShowModal(false);
        setAllItems([]);
        fetchItems(1);
        fetchItemsWithoutUnderscore();
        // if (res.messageCode === "client.module.created") {

        //   fetchItems();
        //   fetchItemsWithoutUnderscore();
        //   // fetchRecordTotal(parentId);
        // }
      } else if (modal === "Update Modal") {
        const res = await MODULE_API.updateClientItem(
          selectedItemId,
          itemsData
        );

        // if (res.status === 200) {
        setIsLoading(false);
        setShowModal(false);
        setAllItems([]);
        await fetchItems(1);
        await fetchItemsWithoutUnderscore();

        // fetchRecordTotal(parentId);
        // }
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  const handleAddItem = async () => {
    setShowModal(true);
    setSelectedRowData({});
    setItemsData({});
    setModal("Add Modal");
    // try {
    //   setIsLoading(true);
    //   let attributesResponce = await MODULE_API.fetchAttributes(
    //     `${selectedModuleName}_item`
    //   );
    //   console.log("attributes responce", attributesResponce);
    //   setAttributesFields(attributesResponce);
    //   setShowModal(true);
    //   setIsLoading(false);
    // } catch (e) {
    //   setIsLoading(false);
    // }
  };

  const getSelectedRow = async (id) => {
    try {
      setModal("Update Modal");

      const selectedRow =
        allItems &&
        allItems.filter((data, index) => {
          if (index === id) {
            return data;
          }
        });

      setSelectedItemId(selectedRow[0].id);

      delete selectedRow[0].id;
      delete selectedRow[0].isShared;
      delete selectedRow[0].module;

      // const pd = selectedRow[0]["Purchase Date"];
      // const date = new Date(pd);
      // /* Date converted to YYYY-MM-DD format */
      // const pdDateMDY = `${date.getFullYear()}-${date.getDate()}-${
      //   date.getMonth() + 1
      // }`;
      // selectedRow[0]["Purchase Date"] = pdDateMDY;

      setSelectedRowData(selectedRow[0]);
      // setSelectedRowData((current) => {
      //   // 👇️ remove id,isShared,module key from object
      //   const { id, isShared, module, ...rest } = current;

      //   return rest;
      // });
      setShowModal(true);
      setItemsData(selectedRow[0]);
    } catch (e) {
      console.log(e);
    }
  };
  const handleView=(id)=>{
    try {
      setModal("View Item");
      const selectedRow =
        allItems &&
        allItems.filter((data, index) => {
          if (index === id) {
            return data;
          }
        });

      setSelectedItemId(selectedRow[0].id);

      delete selectedRow[0].id;
      delete selectedRow[0].isShared;
      delete selectedRow[0].module;
      setSelectedRowData(selectedRow[0]);
      setShowModal(true);
      setItemsData(selectedRow[0]);
    } catch (e) {
      console.log(e);
    }

  }

  const deleteRow = async (id) => {
    try {
      const selectedRow =
        allItems &&
        allItems.filter((data, index) => {
          if (index === id) {
            return data;
          }
        });

      console.log("selectedRow to delete", selectedRow);
      const payload = {
        clientModules: [selectedRow[0].id],
      };

      swal({
        title: "Are you sure?",
        text: "You want to delete this item.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          setIsLoading(true);
          let res = await MODULE_API.deleteItem(payload);
          if (res && res.status === 200) {
            setIsLoading(false);
            setAllItems([]);
            await fetchItems(1);
            if(parentId){
              //  await fetchRecordTotal(parentId);
            }
          }
        } else {
          // swal("Your imaginary file is safe!");
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  console.log("itemsData", itemsData);
  console.log("selected row data", selectedRowData);
  console.log("parentId", parentId);
  console.log("allItems", allItems);
  return (
    <>
      {/* {isLoading ? <div class="loader" ng-hide="data.length > 0"></div> : null} */}

      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            //   rowGap: "1rem",
            marginTop: "2rem",
          }}
        >
          {/* <p
            style={{
              fontSize: "1.5rem",
              backgroundColor: "#4cba5b",
              fontFamily: "Poppins",
              color: "white",
              padding: "0.5rem 2rem",
              borderTopLeftRadius: "50%",
            }}
          >
            {selectedModuleName}
          </p>
          <div style={{ fontSize: "1.2rem", fontFamily: "Poppins" }}>
            <span
              style={{
                fontWeight: "bold",
                fontSize: "1.4rem",
                fontFamily: "Poppins",
              }}
            >
              Total Items :{" "}
            </span>{" "}
            {itemsToshow && itemsToshow.pagination.total}
          </div>
          <div
            style={{
              fontSize: "1.2rem",
              marginBottom: "2rem",
              fontFamily: "Poppins",
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                fontSize: "1.4rem",
                fontFamily: "Poppins",
              }}
            >
              Collectible Value :{" "}
            </span>
            {collectibleValue && collectibleValue}
            </div> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "1rem",
            }}
          >
            <div>
              {" "}
              <h3
                style={{
                  fontWeight: "bold",
                  fontFamily: "Poppins",
                  fontSize: "20px",
                }}
              >
                {selectedModuleName}
              </h3>
            </div>
            <Style.FieldsContainer
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <h3 style={{ fontFamily: "Poppins", fontSize: "20px" }}>
                Add New {selectedModuleName}
              </h3>
              <div
                className="upload"
                onClick={handleAddItem}
                style={{ width: "28px", height: "28px", cursor: "pointer" }}
              >
                <img
                  src={addIcon1}
                  width={12}
                  height={12}
                  style={{ width: "16px", height: "16px" }}
                  alt="addicon"
                ></img>
              </div>
              {/*  <Button style={styles.button.sqaureButton} onClick={handleAddItem}>
              +
            </Button>*/}
            </Style.FieldsContainer>
          </div>
          {message &&
          (itemsToshow === undefined ||
            itemsToshow.itemsRecords.length === 0) ? (
            <div
              style={{ fontSize: "1.7rem", marginTop: "2rem", color: "black" }}
            >
              {" "}
              No Data Found
            </div>
          ) : null}

          {/* <Style.Title>Items</Style.Title> */}
          {/* <Button>Add Item</Button> */}
        </div>

        <Style.CardContainer>
          <Style.CardsMain
            style={{
              justifyContent:
                allItems && allItems.length > 0 ? "start" : "center",
              padding: "8px",
              gap: "1rem",
              height: "40rem",
              overflow: "scroll",
            }}
            id="cards-main"
            onScroll={handleScroll}
          >
            {/* {allProperties? allProperties.length >0: <p>No record found.</p>} */}
            {allItems && allItems.length > 0
              ? allItems.map((item, index) => (
                  <Style.Card key={index} style={{height:"fit-content"}}>
                    <div style={{ overflow: "hidden", padding: "1rem" }}>
                      <Style.Img
                        src={(item.Image && item.Image[0]) || parentImage || `${tableimg}`}
                      />
                    </div>

                    <Style.PropertyCardDetails>
                      <div style={{ paddingTop: "1rem", overflow: "hidden" }}>
                        <Style.PropertyCardH3>
                          {item["Item Name"]}
                        </Style.PropertyCardH3>
                      </div>
                      <div style={{ display: "flex" }}>
                      <div className="custom-field-alignments-icons">
                      <Button
                        type="link"
                        style={{ fontSize: "21px" }}
                        icon="eye"
                        onClick={() => {
                          handleView(index);
                        }}
                      ></Button>
                    </div>
                        <div className="custom-field-alignments-icons">
                          <Button
                            type="link"
                            style={{ fontSize: "21px" }}
                            icon="edit"
                            onClick={() => {
                              getSelectedRow(index);
                            }}
                          ></Button>
                        </div>
                        <div className="custom-field-alignments-icons">
                          <Button
                            type="link"
                            style={{ fontSize: "21px" }}
                            icon="delete"
                            onClick={() => deleteRow(index)}
                          ></Button>
                        </div>
                      </div>
                    </Style.PropertyCardDetails>
                    <Style.Desc
                      style={{
                        paddingInline: "1rem",
                        borderBottom: "1px solid #F0F0F0",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div>
                            <p
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "12px",
                                fontWeight: "400",
                                color: "#8B8D97",
                              }}
                            >
                              Price Paid (each):
                            </p>
                          </div>
                          <div>
                            <p
                              style={{
                                fontWeight: "bold",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                color: "black",
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {item["Price Paid (each)"] || item["Price Paid"]
                                ? item["Price Paid (each)"] || (item["Price Paid"] && item["Price Paid"])
                                : "N/A"}
                            </p>
                          </div>
                        </div>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div>
                            <p
                              style={{
                                fontFamily: "Poppins",
                                fontSize: "12px",
                                fontWeight: "400",
                                color: "#8B8D97",
                              }}
                            >
                              Quantity:
                            </p>
                          </div>
                          <div>
                            <p
                              style={{
                                fontWeight: "bold",
                                color: "black",
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              {item.Quantity ? item.Quantity : "N/A"}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div>
                          <p
                            style={{
                              fontFamily: "Poppins",
                              fontSize: "12px",
                              fontWeight: "400",
                              color: "#8B8D97",
                            }}
                          >
                            Storage Location:
                          </p>
                        </div>
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              color: "black",
                              //   paddingLeft: "0.4rem",
                              fontFamily: "Poppins",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            {item["Storage Location"]
                              ? item["Storage Location"]
                              : "N/A"}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: "flex", width: "90%" }}></div>
                    </Style.Desc>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        paddingInline: "1rem",
                      }}
                    >
                      <div>
                        <p
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: "400",
                            color: "#8B8D97",
                          }}
                        >
                          Total Paid:
                        </p>
                      </div>
                      <div>
                        <p
                          style={{
                            fontWeight: "bold",
                            color: "black",
                            // paddingLeft: "0.4rem",
                            fontFamily: "Poppins",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {item["Total Paid"] ? item["Total Paid"] : "$ 0"}
                        </p>
                      </div>
                    </div>
                  </Style.Card>
                ))
              : null}
          </Style.CardsMain>
          {/*
          {itemsToshow &&
            itemsToshow.itemsRecords.map((item, index) => (
              <StyledRow
                key={index}
                item={item}
                allItems={allItems}
                getSelectedRow={getSelectedRow}
                deleteRow={deleteRow}
                index={index}
                image="required"
              />
            ))} */}
        </Style.CardContainer>
      </div>
      <AddSimpleModal
        show={showModal}
        close={handelCloseModal}
        modalTitle={modal === "Add Modal" ? "Add Item" : 
          modal === "Update Modal" ? "Update Item" : 
          modal === "View Item" ? "View Item" : ""}
        fields={attributesFields}
        onChange={handleItemsInfo}
        onSelectChange={handleItemsInfoSelect}
        submitData={submitData}
        selectedRowData={selectedRowData}
        handleItemsInfoImageChange={handleItemsInfoImageChange}
        loading={isLoading}
      />
      <Loader isLoading={isLoading} />
    </>
  );
}

export default Items;
